<template>
    <BModal
        v-model="visible"
        :title="title || 'Редактор'"
        size="xl"
        :no-header="true"
        ok-title="Гаразд"
        cancel-title="Скасувати"
        @ok="onOk"
        @hidden="onHidden"
    >
        <QuillEditor
            v-model:content="draft"
            contentType="html"
            theme="snow"
            :toolbar="toolbar"
            class="tender-editor"
            style="min-height:320px"
        />
    </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue-next'
import { QuillEditor } from '@vueup/vue-quill'

export default {
    name: 'editor',
    components: { BModal, QuillEditor },
    props: {
        modelValue: { type: String, default: '' },
        show:       { type: Boolean, default: false },
        title:      { type: String, default: '' },
    },
    data() {
        return {
            visible: this.show,
            draft:   this.modelValue,
            toolbar: [
                ['bold', 'italic', 'underline', 'link'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                ['clean']
            ],
        }
    },
    watch: {
        show(v) {
            this.visible = v
            if (v) {
                this.$nextTick(() => {
                    this.draft = this.modelValue ?? ''
                })
            }
        },
        modelValue(v) {
            if (!this.visible) this.draft = v ?? '';
            console.log('v',v,this.draft);
        },
        visible(v) {
            this.$emit('update:show', v);
        },
    },
    methods: {
        onOk() {
            this.$emit('update:modelValue', this.draft ?? '');
        },
        onHidden() {
            this.draft = ''
        },
    },
}
</script>